import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { ApiServiceService } from '../apiService/api-service.service';
import { ApiEndpoints } from './apiEndPoint.model';

@Injectable({
    providedIn: 'root'
})
export class MasterDataService {
    private prefixList: BehaviorSubject<any> = new BehaviorSubject<any>([]);
    private genderList: BehaviorSubject<any> = new BehaviorSubject<any>([]);
    private merrialStatusList: BehaviorSubject<any> = new BehaviorSubject<any>([]);
    private countryList: BehaviorSubject<any> = new BehaviorSubject<any>([]);
    private allDoctorList: BehaviorSubject<any> = new BehaviorSubject<any>([]);
    private allReligionList: BehaviorSubject<any> = new BehaviorSubject<any>([]);
    private allLanguegeList: BehaviorSubject<any> = new BehaviorSubject<any>([]);
    private allNationalityList: BehaviorSubject<any> = new BehaviorSubject<any>([]);
    private allCastList: BehaviorSubject<any> = new BehaviorSubject<any>([]);
    private allPatientCategoryList: BehaviorSubject<any> = new BehaviorSubject<any>([]);
    private relationsList: BehaviorSubject<any> = new BehaviorSubject<any>([]);
    private emergencyTypesList: BehaviorSubject<any> = new BehaviorSubject<any>([]);
    private corporatesOrgList: BehaviorSubject<any> = new BehaviorSubject<any>([]);
    private allMLCTypeList: BehaviorSubject<any> = new BehaviorSubject<any>([]);
    private doctorDataById: Map<string, any> = new Map<string, any>();
    private allDepartmentList: BehaviorSubject<any> = new BehaviorSubject<any>([]);
    private routeList: BehaviorSubject<any> = new BehaviorSubject<any>([]);
    private frequencyList: BehaviorSubject<any> = new BehaviorSubject<any>([]);

    constructor(private apiService: ApiServiceService) {
    }
    // get prefixList for fetching title and if already fetched then return from subject
    getPrefixList(): Observable<any> {
        if (this.prefixList.value?.length > 0) {
            return this.prefixList.asObservable();
        } else {
            return this.apiService.getMasterData(ApiEndpoints.Title).pipe(map((res: any) => {
                this.prefixList.next(res);
                return res;
            }));
        }
    }

    // get MaritalStatus list for fetching title and if already fetched then return from subject
    getMaritalStatusList(): Observable<any> {
        if (this.merrialStatusList.value?.length > 0) {
            return this.merrialStatusList.asObservable();
        } else {
            return this.apiService.getMasterData(ApiEndpoints.MaritalStatus).pipe(map((res: any) => {
                this.merrialStatusList.next(res);
                return res;
            }));
        }
    }

    // get gender list for fetching title and if already fetched then return from subject
    getGenderList(): Observable<any> {
        if (this.genderList.value?.length > 0) {
            return this.genderList.asObservable();
        } else {
            return this.apiService.getMasterData(ApiEndpoints.Gender).pipe(map((res: any) => {
                this.genderList.next(res);
                return res;
            }));
        }
    }

    // get country list and if already fetched then return from subject
    getCountryList(): Observable<any> {
        if (this.countryList.value?.length > 0) {
            return this.countryList.asObservable();
        } else {
            return this.apiService.getMasterData(ApiEndpoints.Country).pipe(map((res: any) => {
                this.countryList.next(res);
                return res;
            }));
        }
    }


    // get all doctor list and if already fetched then return from subject
    getAllDoctorList(): Observable<any> {
        if (this.allDoctorList.value?.length > 0) {
            return this.allDoctorList.asObservable();
        } else {
            return this.apiService.getMasterData(ApiEndpoints.Doctor).pipe(map((res: any) => {
                this.allDoctorList.next(res);
                this.allDepartmentList.value.forEach((dept: any) => {
                    this.doctorDataById.set(dept.id, dept);
                });
                return res;
            }));
        }
    }

    // get all department list and if already fetched then return from subject
    getAllDepartmentList(): Observable<any> {
        if (this.allDepartmentList.value?.length > 0) {
            return this.allDepartmentList.asObservable();
        } else {
            return this.apiService.getMasterData(ApiEndpoints.Department).pipe(map((res: any) => {
                const updatedMap = res.map((x: any) => {
                    return {
                        ...x,
                        ...{
                            code: x.department_code,
                            departmentid: x.id,
                            description: x.department_name
                        }
                    }
                })
                this.allDepartmentList.next(updatedMap);
                return updatedMap;
            }));
        }
    }

    // get doctor info by id
    getDoctorInfo(doctorId: any): Observable<any> {
        if (this.doctorDataById.has(doctorId)) {
            return new BehaviorSubject<any>(this.doctorDataById.get(doctorId)).asObservable();
        } else {
            return this.apiService.getMasterData(`${ApiEndpoints.Doctor}/${doctorId}`).pipe(map((res: any) => {
                this.doctorDataById.set(doctorId, res);
                return res;
            }));
        }
    }

    // get all religion list and if already fetched then return from subject
    getReligionList(): Observable<any> {
        if (this.allReligionList.value?.length > 0) {
            return this.allReligionList.asObservable();
        } else {
            return this.apiService.getMasterData(ApiEndpoints.Religion).pipe(map((res: any) => {
                this.allReligionList.next(res);
                return res;
            }));
        }
    }

    // get all language list and if already fetched then return from subject
    getLanguageList(): Observable<any> {
        if (this.allLanguegeList.value?.length > 0) {
            return this.allLanguegeList.asObservable();
        } else {
            return this.apiService.getMasterData(ApiEndpoints.Language).pipe(map((res: any) => {
                this.allLanguegeList.next(res);
                return res;
            }));
        }
    }

    // get nationality list and if already fetched then return from subject
    getNationalityList(): Observable<any> {
        if (this.allNationalityList.value?.length > 0) {
            return this.allNationalityList.asObservable();
        } else {
            return this.apiService.getMasterData(ApiEndpoints.Nationality).pipe(map((res: any) => {
                this.allNationalityList.next(res);
                return res;
            }));
        }
    }

    // get mlctypes list and if already fetched then return from subject
    getMLCTypesList(): Observable<any> {
        if (this.allMLCTypeList.value?.length > 0) {
            return this.allMLCTypeList.asObservable();
        } else {
            return this.apiService.getMasterData(ApiEndpoints.MlcTypes).pipe(map((res: any) => {
                this.allMLCTypeList.next(res);
                return res;
            }));
        }
    }

    // get cast list and if already fetched then return from subject
    getCastList(): Observable<any> {
        if (this.allCastList.value?.length > 0) {
            return this.allCastList.asObservable();
        } else {
            return this.apiService.getMasterData(ApiEndpoints.Caste).pipe(map((res: any) => {
                this.allCastList.next(res);
                return res;
            }));
        }
    }

    // get cast list and if already fetched then return from subject
    getPatientCategoryList(): Observable<any> {
        if (this.allPatientCategoryList.value?.length > 0) {
            return this.allPatientCategoryList.asObservable();
        } else {
            return this.apiService.getMasterData(ApiEndpoints.PatientCategory).pipe(map((res: any) => {
                this.allPatientCategoryList.next(res);
                return res;
            }));
        }
    }

    // get relations list and if already fetched then return from subject
    getRelationsList(): Observable<any> {
        if (this.relationsList.value?.length > 0) {
            return this.relationsList.asObservable();
        } else {
            return this.apiService.getMasterData(ApiEndpoints.Relation).pipe(map((res: any) => {
                this.relationsList.next(res);
                return res;
            }));
        }
    }

    getEmergencyTypeList(): Observable<any> {
        if (this.emergencyTypesList.value?.length > 0) {
            return this.emergencyTypesList.asObservable();
        } else {
            return this.apiService.getMasterData(ApiEndpoints.EmergencyTypes).pipe(map((res: any) => {
                this.emergencyTypesList.next(res);
                return res;
            }));
        }
    }

    getCorporateCompanyList(): Observable<any> {
        if (this.corporatesOrgList.value?.length > 0) {
            return this.corporatesOrgList.asObservable();
        } else {
            return this.apiService.getMasterData(ApiEndpoints.CorporateCompany).pipe(map((res: any) => {
                this.corporatesOrgList.next(res);
                return res;
            }));
        }
    }

    getRouteList(): Observable<any> {
        if (this.routeList.value?.length > 0) {
            return this.routeList.asObservable();
        } else {
            return this.apiService.getMasterData(ApiEndpoints.Route).pipe(map((res: any) => {
                this.routeList.next(res);
                return res;
            }));
        }
    }

    getFrequencyList(): Observable<any> {
        if (this.frequencyList.value?.length > 0) {
            return this.frequencyList.asObservable();
        } else {
            return this.apiService.getMasterData(ApiEndpoints.Frequency).pipe(map((res: any) => {
                this.frequencyList.next(res);
                return res;
            }));
        }
    }

    getTeleDepartmentList(): Observable<any> {
        return this.apiService.getMasterData(ApiEndpoints.TeleConsultationDepartments);
    }
}
